import axios from "axios";
import store from "@/store";

class CaValidationService {
  constructor() {
    this.validationBaseUrl =
      "https://n8n.devops.multpex.com.br/webhook/8b55a205-c76f-4ab5-b016-6290eac3ef49";
  }

  /**
   * Valida um CA através do endpoint externo (para abrir o modal)
   * @param {string} caNumber - Número do CA a ser validado
   * @returns {Promise<Object>} - Resposta com status e validade do CA
   */
  async validateCa(caNumber) {
    try {
      const response = await axios.get(
        `${this.validationBaseUrl}?ca=${caNumber}`
      );

      // A resposta vem como array, pegamos o primeiro item
      const rawData = Array.isArray(response.data)
        ? response.data[0]
        : response.data;

      // Verifica se os dados estão vazios (CA não encontrado)
      if (
        !rawData ||
        !rawData.CA ||
        !rawData.name ||
        !rawData.status ||
        !rawData.data_validade
      ) {
        return {
          success: false,
          error: "CA não encontrado na base, contate o suporte!",
        };
      }

      // Transformamos para a estrutura esperada pelo modal
      const transformedData = {
        status: rawData.status,
        expires_in: this.convertDateFormat(rawData.data_validade),
        additional_info: `Produto: ${rawData.name}`,
        ca_number: rawData.CA,
      };

      return {
        success: true,
        data: transformedData,
      };
    } catch (error) {
      console.error("Erro ao validar CA:", error);
      return {
        success: false,
        error: error.response?.data?.message || "Erro ao validar CA",
      };
    }
  }

  /**
   * Converte data do formato DD/MM/YYYY para formato ISO
   * @param {string} dateString - Data no formato DD/MM/YYYY
   * @returns {string} - Data no formato ISO
   */
  convertDateFormat(dateString) {
    if (!dateString) return null;

    try {
      const [day, month, year] = dateString.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    } catch {
      return dateString;
    }
  }

  /**
   * Atualiza a validade do CA no sistema Multpex (botão "Atualizar Validade" no modal)
   * @param {number} caId - ID do CA no sistema Multpex
   * @param {Object} validationData - Dados de validação recebidos do endpoint
   * @returns {Promise<Object>} - Resposta da atualização
   */
  async updateCaValidity(caId, validationData) {
    try {
      // Converte a data de volta para o formato DD/MM/YYYY se necessário
      const expiresIn = validationData.expires_in.includes("-")
        ? this.convertIsoToDateFormat(validationData.expires_in)
        : validationData.expires_in;

      const payload = {
        expires_in: expiresIn,
        id: caId,
        code: validationData.ca_number,
      };

      const apiLegado = store.state.autenticacao.apiLegado;
      const response = await apiLegado.put(`/cas/${caId}`, payload);

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      console.error("Erro ao atualizar CA:", error);
      return {
        success: false,
        error: error.response?.data?.message || "Erro ao atualizar CA",
      };
    }
  }

  /**
   * Converte data do formato ISO para DD/MM/YYYY
   * @param {string} isoDateString - Data no formato ISO
   * @returns {string} - Data no formato DD/MM/YYYY
   */
  convertIsoToDateFormat(isoDateString) {
    if (!isoDateString) return null;

    try {
      const [year, month, day] = isoDateString.split("-");
      return `${day}/${month}/${year}`;
    } catch {
      return isoDateString;
    }
  }
}

export default new CaValidationService();
